import {
  Component,
  effect,
  EventEmitter,
  HostListener,
  input,
  InputSignal,
  OnInit,
  Output,
} from '@angular/core';
import { Column, ColumnType, SelectedItem } from '@shared/components/simple-table/models/simple-table-model';
import { SortState } from '@shared/components/simple-table/models/sort-state.model';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { ActionButton } from '@shared/models/action-button.model';
import { trackByFn } from '@shared/functions/track-by-id';
import { NgIf, NgClass } from '@angular/common';
import { SortableHeaderComponent } from './components/sortable-header/sortable-header.component';
import { TableCellComponent } from './components/table-cell/table-cell.component';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MobileTableComponent } from './components/mobile-table/mobile-table.component';
import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-simple-table',
    templateUrl: './simple-table.component.html',
    styleUrls: ['./simple-table.component.scss'],
    imports: [NgIf, MatCheckbox, SortableHeaderComponent, NgClass, TableCellComponent, MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, MobileTableComponent, TranslatePipe]
})
export class SimpleTableComponent implements OnInit {
  readonly DISABLED_SUFFIX = 'Disabled';
  readonly MOBILE_SCREEN_ZISE = 768;
  readonly trackByFn = trackByFn;

  readonly columns = input<Column[]>([]);
  readonly actions = input<ActionButton[]>([]);
  readonly isAdvancedColumns = input<boolean>(false);
  readonly allowSelection = input<boolean>(false);
  readonly selectedItems = input<SelectedItem[]>([]);
  readonly items = input<any[]>([]);
  readonly emptyMessage = input<string>('');
  readonly sortState = input<SortState>({ sortKey: null, sortDir: null });

  @Output()
  sortChange: EventEmitter<string> = new EventEmitter();

  @Output()
  selectionChange: EventEmitter<SelectedItem[]> = new EventEmitter();

  @Output()
  action: EventEmitter<ActionButton> = new EventEmitter();

  @Output()
  rowClick: EventEmitter<any> = new EventEmitter();

  data: any[] = [];

  columnType = ColumnType;
  isMobile: boolean = false;

  constructor() {
    effect(() => {
      const parentItems = this.items();
      const parentSelectedItems = this.selectedItems();

      const selectedIds = new Set(parentSelectedItems?.map((item) => item.id));

      this.data = parentItems.map((item) => ({
        ...item,
        selected: selectedIds.has(item.id),
      }));
    });
  }

  ngOnInit(): void {
    this.isMobileVerification();
  }

  changeAllCheckboxes(change: MatCheckboxChange): void {
    this.data.forEach((data) => {
      if (data.selectable !== false) {
        data.selected = change.checked;
      }
    });
    this.verifySelectedCheckboxes();
  }

  verifySelectedCheckboxes(): void {
    const newSelection = this.data
      .filter((item) => item.selected)
      .map((item) => ({ id: item.id }));

    this.selectionChange.emit(newSelection);
  }

  emitAction(action: ActionButton, index: number, row?: any): void {
    action.index = index;
    if (row !== undefined) {
      action.row = row;
    }
    this.action.emit(action);
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobileVerification();
  }

  isMobileVerification(): void {
    this.isMobile = window.innerWidth <= this.MOBILE_SCREEN_ZISE;
  }

  /** aria-sort do <th> da coluna ordenável, refletindo o estado atual. */
  sortAriaFor(column: Column): 'ascending' | 'descending' | 'none' {
    const key = column.sortKey || column.id;
    const state = this.sortState();
    if (state.sortKey !== key || !state.sortDir) return 'none';
    return state.sortDir === 'asc' ? 'ascending' : 'descending';
  }

  onStatusClick(event: { row: any; column: Column }): void {
    this.action.emit({
      type: ColumnType.STATUS_ACTION,
      row: event.row,
      column: event.column,
    } as any);
  }

  emitActionFromMobile(event: {
    action: ActionButton;
    row: any;
    index?: number;
  }): void {
    const action = event.action;
    action.row = event.row;
    this.emitAction(action, event.index !== undefined ? event.index : -1);
  }
}
